import React,{ Component } from 'react';
import { withRouter } from 'react-router-dom';

import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import PortletContent from 'components/PortletContent';
import PerfectScrollbar from 'react-perfect-scrollbar';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import 'moment/locale/es';
import { getDetalleDisponibilidadConsolidada } from '../../../../../services/getDetalleDisponibilidadConsolidada';
import { getDetalleDisponibilidadConsolidadaCustom } from '../../../../../services/getDetalleDisponibilidadConsolidadaCustom';
moment.locale('es')

class AvailabilityDowntime extends Component {

    constructor(props) {
        super(props);
        // console.log('ava', this.props)
        var periodical=false
        if(this.props.params.periodical===true){
            periodical=true
        }
        var periodicalView = props.params.periodicalView
        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            name:this.props.params.name,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            rows: null,
            noMonCum: null,
            downCum: null,
            date: this.props.params.date,
            dateMoment: ((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")),
            isRefresh: this.props.params.isRefresh,
            periodical:periodical,
            periodicalView : periodicalView
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (props.match.params.objetivo_id !== state.prevObjectiveId) {
            return {
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
            }
        } else if (props.params.period !== state.time) {
            return {
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        }  else if(props.params.isRefresh !== state.isRefresh){
            return {
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isRefresh: props.params.isRefresh,          
            }

        } else if ((props.params.period === state.time) && (props.params.statePeriod !== state.statePeriod)) {
            return {
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        }
        return null;
    }


    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }

        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) ||
            (prevProps.params.isRefresh !== this.state.isRefresh) ||
            (prevProps.params.statePeriod !== this.state.statePeriod)) {
            this.getDataFromAPI();
        }

    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        const { objetivo_id } = this.props.match.params
        const { fromObjective } = this.props.location.state
        const { period, statePeriod, node } = this.props.params
        let fecha_inicio = moment().subtract(1,"days").locale('es').format("YYYY-MM-DD HH:mm:ss")
        let fecha_termino = moment().locale('es').format("YYYY-MM-DD HH:mm:ss")
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
        }
        //console.log(period,fecha_inicio, fecha_termino)
        if(period!=="c"){
            Promise.all([
                getDetalleDisponibilidadConsolidada(user, objetivo_id, period, node, token)
            ])
            .then(([value]) => {
                return Promise.all([value.json()])
            })
            .then(value=>{
                try {
                    //console.log(value.json())
                    this.processData(value[0].Objetivo, period, fecha_inicio, fecha_termino) 
                } catch (error) {
                    this.setState({
                        dataError: true,
                        isLoading: false
                    });
                }
            })
        }else{
            Promise.all([
                getDetalleDisponibilidadConsolidadaCustom(user,objetivo_id, 0, fecha_inicio, fecha_termino, token, 0)
            ])
            .then(([value]) => {
                return Promise.all([value.json()])
            })    
            .then(value=>{
                try {
                    //console.log(value)
                    this.processData(value[0].Objetivo, period, fecha_inicio, fecha_termino) 
                } catch (error) {
                    this.setState({
                        dataError: true,
                        isLoading: false
                    });
                }
            })
        } 
        
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,period,fecha_inicio,fecha_termino) => {
        var arrayRows = []
        
        let noMonCum=0
        let downCum=0
        let noMonCumDate = null
        let downCumDate = null
        let global = externalData.Global
        global.map(ele=>{
            ele.estado.map(states=>{
                if(states.nombre==="no monitoreo" || states.nombre==="downtime"){
                    
                    var monCum = {}
                    var duration=moment(states.fecha_hasta)-moment(states.fecha_desde)
                    monCum["tiempo_duracion"]=duration
                    var date=states.fecha_desde.substring(0,10)
                    var name=states.nombre
                    var begin=states.fecha_desde.substring(11,19)
                    var final=states.fecha_hasta.substring(11,19)
                    duration=new Date(duration).toISOString().substring(11,19)
                    monCum["duracion"]=duration
                    monCum["fecha"]=date
                    monCum["hora_inicio"]=begin
                    monCum["hora_termino"]=final
                    monCum["fecha_inicio"]=moment(states.fecha_desde)
                    monCum["fecha_termino"]=moment(states.fecha_hasta)
                    monCum["fechaStrInicio"]=states.fecha_desde
                    monCum["fechaStrTermino"]=states.fecha_hasta
                    monCum["nombre"]=name
                    if (states.nombre!=="no monitoreo" && duration !=="00:00:00"){
                        arrayRows.push(monCum)
                    }
                }
            })
            
        })
        //arrayRows=([...new Map(arrayRows.map(item => [item["fechaStr"], item])).values()])
        arrayRows.sort(function (a, b) {
            return (a.fecha_inicio - b.fecha_inicio);
        });
        /*var arrayRowsConsolidated = []
        var horaInicioAux = 0
        var horaTerminoAux = 0
        var nameAux = ""
        var fechaAux = ""
        var fechaInicioAux = ""
        var fechaTerminoAux = ""
        var first = true
        var length = arrayRows.length
        arrayRows.map((event, key) => {
            if (first){
                horaInicioAux = event.hora_inicio
                horaTerminoAux = event.hora_termino
                fechaInicioAux = event.fechaStrInicio
                fechaTerminoAux = event.fechaStrTermino
                nameAux = event.nombre
                fechaAux = event.fecha
                first = false
            }else{
                if (event.fecha != fechaAux || event.hora_inicio > horaTerminoAux || (key+1) === length){
                    if ((key+1) === length){
                        if(event.hora_termino > horaTerminoAux){
                            horaTerminoAux = event.hora_termino
                            fechaTerminoAux = event.fechaStrTermino
                        }
                    }
                    //guardar array
                    var monCum = {}
                    var duration=moment(fechaTerminoAux)-moment(fechaInicioAux)
                    monCum["tiempo_duracion"]=duration
                    duration=new Date(duration).toISOString().substr(11, 8)
                    monCum["duracion"] = duration
                    monCum["fecha"] = fechaAux
                    monCum["hora_inicio"] = horaInicioAux
                    monCum["hora_termino"] = horaTerminoAux
                    monCum["nombre"] = nameAux
                    arrayRowsConsolidated.push(monCum)
                    horaInicioAux = event.hora_inicio
                    horaTerminoAux = event.hora_termino
                    fechaInicioAux = event.fechaStrInicio
                    fechaTerminoAux = event.fechaStrTermino
                    nameAux = event.nombre
                    fechaAux = event.fecha
                }else{
                    if(event.hora_termino > horaTerminoAux){
                        horaTerminoAux = event.hora_termino
                        fechaTerminoAux = event.fechaStrTermino
                    }
                }
            }
        })
        */
        if(arrayRows.length>0){
            noMonCum = arrayRows.reduce((sum, value) => (value.nombre == "no monitoreo" ? sum + value.tiempo_duracion : sum), 0)
            noMonCum=new Date(noMonCum).toISOString().substring(11,19)
            downCum = arrayRows.reduce((sum, value) => (value.nombre == "downtime" ? sum + value.tiempo_duracion : sum), 0)
            if (downCum < 86400000) {
                downCum=new moment(downCum).toISOString().substring(11,19)
            } else {
                let hhmmss = new moment(downCum).toISOString().substring(11,19)
                let days = Math.floor(downCum / 1000 / 60 / 60 / 24)
                downCum = `${days} día(s) ${hhmmss}`
            }
        }
        
        
        this.setState({
            rows : arrayRows,
            noMonCum : noMonCum,
            downCum : downCum,
            isLoading: false,
            time: period,
            //step: step,
            dataError: false,
        });

    }
    render() {
        const { dataError, isLoading, rows, noMonCum, downCum, periodical, name,periodicalView } = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };
        sessionStorage.setItem("AvailabilityTableDownCum",downCum)
        sessionStorage.setItem("AvailabilityTableNoMonCum",noMonCum)

  
        if (!dataError) {
            return (<FormattedChart rows={rows} periodical={periodical} name={name} noMonCum={noMonCum}
                 downCum={downCum} isLoading={isLoading} style={style} styleHidden={styleHidden} periodicalView={periodicalView} />) 
        }
        else if (dataError) {
            return (<p>No hay datos..</p>)
        }
        else return (<p> Error!</p >)

    }
}

function FormattedChart(props) {
    const periodical=props.periodical
    //console.log("formatted", props.style)
    return (
        <div >
            <div style={props.styleHidden}>
            <PortletContent>
                <PerfectScrollbar>

                    <Typography
                      variant="h5"
                    >
                     <CircularProgress
                      variant="indeterminate"

                      size={24}
                      thickness={4}
                      
                    />
                    <br/>
                     Cargando Información...
                   </Typography>
                  </PerfectScrollbar>
            </PortletContent>
            </div>
            <div style={props.style}>
                { props.rows == null  ? 

                    <Table  aria-label="spanning table" >
                    <TableHead >
                        <TableRow>
                            <TableCell>Fecha Inicio</TableCell>
                            <TableCell>Hora Inicio</TableCell>
                            <TableCell>Hora termino</TableCell>
                            <TableCell>Duración</TableCell>
                            <TableCell>Tipo</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell rowSpan={3} />
                            <TableCell colSpan={3}>Sin Caidas Globales</TableCell>
                                                        
                        </TableRow>
                        
                        <TableRow>
                            <TableCell rowSpan={3} />
                            <TableCell colSpan={3}>Downtime Acumulado</TableCell>
                            
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={3}>No monitoreo Acumulado</TableCell>
                            
                        </TableRow>
                    </TableBody>
                    </Table>
                    
                   
                : Object.keys(props.style).length===0?periodical===false?tableData(props):tableDataPeriodical(props):null}
            </div>
        </div>
        )

}
function tableDataPeriodical(props){
    // console.log("tableDataPeriodical", props)
    if(props.rows.length<15 || props.periodicalView == true){
        return tableData(props)
    }else{
        var styleTable={}
        if(props.periodical===true){
            styleTable={border:"1px solid black"}
        }
        var i,j, temporary, chunk = 15;
        var cont=0
        var Tables=[]
        
        for (i = 0,j = props.rows.length; i < j; i += chunk) {
            var temporary = props.rows.slice(i, i + chunk);
            // console.log("temporary",temporary)
            sessionStorage.setItem("AvailabilityDowntimeTables_"+cont,JSON.stringify(temporary))
            var sessionContTable=parseInt(sessionStorage.getItem("AvailabilityDowntimeContTables"))
            var tBody=<TableBody>
                        {temporary.map(row=>(
                            <TableRow >
                                <TableCell>{row.fecha}</TableCell>
                                <TableCell>{row.hora_inicio}</TableCell>
                                <TableCell>{row.hora_termino}</TableCell>
                                <TableCell>{row.duracion}</TableCell>
                                <TableCell>{row.nombre}</TableCell>
                            </TableRow>
                        ))}
                        {sessionContTable===cont+1?
                        <TableRow>
                            <TableCell />
                            <TableCell colSpan={3}>DownTime Acumulado</TableCell>
                            <TableCell>{props.downCum}</TableCell>
                        </TableRow>
                        :null}
                        {sessionContTable===cont+1?
                            <TableRow>
                                <TableCell />
                                <TableCell colSpan={3}>No monitoreo Acumulado</TableCell>
                                <TableCell>{props.noMonCum}</TableCell>
                            </TableRow>
                        :null}
                    </TableBody>
            var table =<Table style={styleTable} id={"table_"+cont} aria-label="spanning table" >
                        <TableHead >
                            <TableRow style={{textAlign:"center"}}>
                                <TableCell colSpan={5}>{props.name}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Fecha Inicio</TableCell>
                                <TableCell>Hora Inicio</TableCell>
                                <TableCell>Hora termino</TableCell>
                                <TableCell>Duración</TableCell>
                                <TableCell>Tipo</TableCell>
                            </TableRow>
                        </TableHead>
                        {tBody}
                        </Table>
            Tables.push(table)
            cont++   
        }
        sessionStorage.setItem("AvailabilityDowntimeContTables", cont)
    }
    return Tables
}

function tableData(props){
    //console.log("tabledata")
    sessionStorage.setItem("AvailabilityDowntimeContTables", 1)
    const row =props.rows
    sessionStorage.setItem("AvailabilityDowntimeTables_"+0,JSON.stringify(row))
    let nameperiod = sessionStorage.getItem('namePeriodAvailaTable')

    sessionStorage.setItem("AvailabilityDowntimeTablesGlobal",JSON.stringify(({'header':[{'fecha':"Fecha Inicio"},{'hora_inicio':"Hora Inicio"},
                                                                        {'hora_termino':"Hora Termino"},{'duracion':"Duración"},{'nombre':"Tipo"}],
                                                                        'data':props.rows,'title':'Disponibilidad Downtime Global','subtitle':nameperiod,
                                                                        'dynamic':[{'nombre':'Downtime Acumulado','colSpan':3,'value':props.downCum},
                                                                        {'nombre':'No monitoreo Acumulado','colSpan':3,'value':props.noMonCum}]})))

    var styleTable={}
    if(props.periodical===true){
        styleTable={border:"1px solid black"}
    }
    return <Table style={styleTable} id="table_0" aria-label="spanning table" >
            <TableHead>
            <TableRow>
                    <TableCell colSpan={5}>{props.name}</TableCell>
                </TableRow>
                <TableRow>
                    {/* TABLA ONLINE DOWNTIME GLOBAL */}
                    <TableCell>Fecha Inicio</TableCell>
                    <TableCell>Hora Inicio</TableCell>
                    <TableCell>Hora termino</TableCell>
                    <TableCell>Duración</TableCell>
                    <TableCell>Tipo</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {props.rows.map(row => (
                    <TableRow >
                        <TableCell>{row.fecha}</TableCell>
                        <TableCell>{row.hora_inicio}</TableCell>
                        <TableCell>{row.hora_termino}</TableCell>
                        <TableCell>{row.duracion}</TableCell>
                        <TableCell>{row.nombre}</TableCell>
                    </TableRow>
                ))}
                <TableRow>
                    <TableCell rowSpan={3} />
                    <TableCell colSpan={3}>Downtime Acumulado</TableCell>
                    <TableCell>{props.downCum}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell colSpan={3}>No monitoreo Acumulado</TableCell>
                    <TableCell>{props.noMonCum}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
}


export default withRouter(AvailabilityDowntime);